module.exports = __webpack_public_path__ + "static/images/components/Back/images/shine.f818f6ce.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/shine.png
// module id = 2498
// module chunks = 11